export const defaultForm = {
        currentStep: 'step0',
        formInWork: false,
        steps: 19,
        step0: {
          debt: 500000,
          fermer: 'Нет',
          businessman: 'Нет',
          stepNumber: 0,
          stepName: 'Начало',
          nextStep: 'step1',
          prevStep: '',
        },
        step1: {
          personalData: false,
          surname: '',
          name: '',
          middlename: '',
          birthDate: '',
          birthPlace: '',
          passpSerie: '',
          passpNumber: '',
          passpIssued: '',
          passpDate: '',
          passpCode: '',
          regionOfRegistration: '',
          registrationAddress: '',
          liveAddress: '',
          inn: '',
          snils: '',
          phoneNumber: '',
          email: '',
          stepName: 'Шаг 1: ФИО и адрес',
          stepNumber: 1,
          nextStep: 'step2',
          prevStep: 'step0',
        },
        step2: {
          realEstate: 'Не владею',
          realEstateData: [],
          realEstateType: '',
          movableProperty: 'Не владею',
          movablePropertyData: [],
          movablePropertyType: '',
          banksAccounts: 'Не имею',
          banksAccountsData: [],
          bussiness: 'Не имею',
          bussinessData: [],
          stock: 'Не владею',
          stocksData: [],
          money: 'Не владею',
          moneyData: [],
          stepName: 'Шаг 2: Собственность',
          stepNumber: 2,
          nextStep: 'step3',
          prevStep: 'step1',
        },
        step3: {
          transactions: 'Не совершал',
          transactionsData: [],
          stepName: 'Шаг 3: ПРОДАЖА ИМУЩЕСТВА',
          stepNumber: 3,
          nextStep: 'step4',
          prevStep: 'step2',
        },
        step4: {
          marriage: 'Не состою',
          spouseName: '',
          marriageDate: '',
          marriageAggrDate: '',
          marriageData: [],
          spouseProperty: 'Не имеет',
          spousePropertyData: [],
          dissolution: 'Не расторгал',
          dissolution_marriageDate: '',
          dissolution_marriageAggrDate: '',
          agreement: 'Не имею',
          childs: 'Не имею',
          childsData: [],
          stepName: 'Шаг 4: СЕМЕЙНОЕ ПОЛОЖЕНИЕ',
          stepNumber: 4,
          nextStep: 'step5',
          prevStep: 'step3',
        },
        step5: {
          status: "",
          job: "",
          post: "",
          dosc: "",
          sum: "",
          date: "",
          stepName: 'Шаг 5: ТРУДОУСТРОЙСТВО',
          stepNumber: 5,
          nextStep: 'step6',
          prevStep: 'step4',
        },
        step6 :{
          lender1a: 'Нет',
          lenderMoneyData: [],
          lenderMoneyDataPayments: [],
          lender1b: 'Нет',
          lenderNoMoneyData: [],
          lender2a: 'Нет',
          lenderMoneyDataIP: [],
          lenderMoneyDataPaymentsIP: [],
          lender2b: 'Нет',
          lender2bData: [],
          lender3a: 'Нет',
          lender3aData: [],
          lender3aDataPayments: [],
          lender3b: 'Нет',
          lender3bData: [],
          lender4a: 'Нет',
          lender4aData: [],
          lender4aDataPayments: [],
          lender4b: 'Нет',
          lender4bData: [],
          stepName: 'Шаг 6: СВЕДЕНИЯ О КРЕДИТОРАХ И ДОЛЖНИКАХ',
          stepNumber: 6,
          nextStep: 'step7',
          prevStep: 'step5',
        },
        step7: {
          case: 'Не ведутся',
          caseData: [],
          stepName: 'Шаг 7: Судебные процессы',
          stepNumber: 7,
          nextStep: 'step8',
          prevStep: 'step6',
        },
        step8:{
          procedure: 'Не ведутся',
          procedureData: [],
          stepName: 'Шаг 8: Исполнительные производства',
          stepNumber: 8,
          nextStep: 'step9',
          prevStep: 'step7',
        },
        step9: {
          selectedSROName: '',
          selectedSROList: [],
          stepName: 'Шаг 9: Выбор СРО',
          stepNumber: 9,
          nextStep: 'step10',
          prevStep: 'step8',
        },
        step10: {
          payment: 'Средства внесены',
          amountToManager: 'Не вношу',
          stepName: 'Шаг 10: Внесение ДС на счет суда',
          stepNumber: 10,
          nextStep: 'step11',
          prevStep: 'step9',
        },
        step11 : {
          docs: [],
          stepName: 'Шаг 11: Список необходимых документов',
          stepNumber: 11,
          nextStep: 'step12',
          prevStep: 'step10',
        },
        step12 :{
          stepName: 'Шаг 12: Итоговый документ',
          stepNumber: 11,
          nextStep: '',
          prevStep: 'step11',
        },
      }